import * as React from "react";

import { SearchFormEvents } from "../../components/organisms";
import { sendEventRequest } from "../../services/api/event";
import { dateFromIso } from "../../utils/dateIso";

interface IProps {
  event?: string;
  isEventDisabled?: boolean;
  isNoHeader?: boolean;
  onFormSubmitted?: () => void;
}

interface IState {
  date: string;
  email: string;
  event: string;
  isShowTooltip: boolean;
  notes: string;
  selectedDate?: string;
  time: string;
  isFormSent: boolean;
  isFormSentError: boolean;
}

const INITIAL_STATE = {
  date: "",
  email: "",
  event: "",
  isShowTooltip: false,
  notes: "",
  selectedDate: undefined,
  time: "",
};

class SearchFormEventsContainer extends React.Component<IProps, IState> {
  private readonly maxLength = 4000;
  private readonly minLength = 20;

  public state: IState = {
    ...INITIAL_STATE,
    ...(this.props.event ? { event: this.props.event } : undefined),
    isFormSent: false,
    isFormSentError: false,
  };

  /**
   * Check and hide tooltip
   */
  private hideTooltip() {
    if (this.state.isShowTooltip) {
      this.setState({ isShowTooltip: false });
    }
  }

  public selectDate = (date: string) => {
    const formattedDate = dateFromIso(date).toFormat("cccc, LLLL dd, yyyy");
    this.setState({ selectedDate: date, date: formattedDate });
    this.hideTooltip();
  };

  public setEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: e.currentTarget.value });
    this.hideTooltip();
  };

  public selectEvent = (event: string) => {
    this.setState({ event });
    this.hideTooltip();
  };

  public setNotes = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ notes: e.currentTarget.value });
    this.hideTooltip();

    e.currentTarget.style.height = "inherit";
    const computed = window.getComputedStyle(e.currentTarget);
    const height =
      parseInt(computed.getPropertyValue("border-top-width"), 10) +
      parseInt(computed.getPropertyValue("padding-top"), 10) +
      e.currentTarget.scrollHeight +
      parseInt(computed.getPropertyValue("padding-bottom"), 10) +
      parseInt(computed.getPropertyValue("border-bottom-width"), 10);

    e.currentTarget.style.height = `${height}px`;
  };

  public selectTime = (time: string) => {
    this.setState({ time });
    this.hideTooltip();
  };

  public resetForm = () => {
    this.setState({ isFormSent: false });
  };

  public resetFormError = () => {
    this.setState({ isFormSentError: false });
  };

  public submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (
      e.currentTarget.checkValidity() &&
      Boolean(
        [this.state.date, this.state.event, this.state.time] &&
          this.state.notes.length > this.minLength &&
          this.state.notes.length < this.maxLength,
      )
    ) {
      const formData = {
        date: this.state.date,
        email: this.state.email,
        event: this.state.event,
        notes: this.state.notes,
        time: this.state.time,
      };

      try {
        await sendEventRequest(formData);
        this.setState({ isFormSent: true });

        if (typeof this.props.onFormSubmitted !== "undefined") {
          this.props.onFormSubmitted();
        }
      } catch (_e) {
        this.setState({ isFormSentError: true });
      } finally {
        const state = {
          ...INITIAL_STATE,
          ...(this.props.event ? { event: this.props.event } : undefined),
        };

        this.setState(state);
      }
    } else {
      this.setState({ isShowTooltip: true });
    }
  };

  /**
   * Render events form
   */
  public render() {
    return (
      <SearchFormEvents
        email={this.state.email}
        isShowTooltip={this.state.isShowTooltip}
        notes={this.state.notes}
        onDateSelect={this.selectDate}
        onEmailChange={this.setEmail}
        onEventSelect={this.selectEvent}
        onNotesChange={this.setNotes}
        onSubmit={this.submitForm}
        onTimeSelect={this.selectTime}
        selectedDate={this.state.selectedDate}
        selectedEvent={this.state.event}
        selectedTime={this.state.time}
        isFormSent={this.state.isFormSent}
        isFormSentError={this.state.isFormSentError}
        isEventDisabled={this.props.isEventDisabled}
        isNoHeader={this.props.isNoHeader}
        resetForm={this.resetForm}
        resetFormError={this.resetFormError}
      />
    );
  }
}

export { SearchFormEventsContainer };
